module.exports = __webpack_public_path__ + "static/a1-d554b65bb0141571fa25a4d81f0abe09.svg";